(function () {
  'use strict';

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-impdp]')).forEach(init);
  }

  function init(root) {
    var form = root.querySelector('form.impdp__form');
    var atc = root.querySelector('[data-add-to-cart]');
    var atcText = root.querySelector('[data-add-to-cart-text]');
    var status = root.querySelector('[data-form-status]');
    var variantInput = root.querySelector('[data-variant-input]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    if (!form || !atc || !variantInput || !quantityInput) return;

    var pending = false;
    var snapshot = [];

    function controls() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-option-button], [data-quantity-minus], [data-quantity-plus], [data-quantity-input], [data-add-to-cart]'));
    }

    function setStatus(message, reviewCart) {
      if (!status) return;
      status.textContent = message || '';
      if (reviewCart) {
        status.appendChild(document.createTextNode(' '));
        var link = document.createElement('a');
        link.href = '/cart';
        link.textContent = 'Review cart';
        status.appendChild(link);
      }
    }

    function lockControls() {
      snapshot = controls().map(function (control) {
        return { control: control, disabled: Boolean(control.disabled) };
      });
      snapshot.forEach(function (entry) { entry.control.disabled = true; });
      atc.setAttribute('aria-busy', 'true');
    }

    function restoreControls() {
      snapshot.forEach(function (entry) { entry.control.disabled = entry.disabled; });
      snapshot = [];
      atc.removeAttribute('aria-busy');
    }

    function quantityFor(cart, variantId) {
      if (!cart || !Array.isArray(cart.items)) return 0;
      return cart.items.reduce(function (sum, item) {
        return String(item.variant_id) === String(variantId) ? sum + Number(item.quantity || 0) : sum;
      }, 0);
    }

    async function readCart() {
      var response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart read failed (' + response.status + ').');
      return response.json();
    }

    async function responseMessage(response) {
      try {
        var data = await response.clone().json();
        return String(data.description || data.message || data.error || '').trim();
      } catch (error) {
        try {
          var text = String(await response.clone().text()).trim().slice(0, 180);
          return /<(?:!doctype|html|head|body)\b/i.test(text) ? '' : text;
        } catch (ignored) {
          return '';
        }
      }
    }

    function normalizedQuantity() {
      var value = parseInt(quantityInput.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function retryableFailure(message, originalText) {
      pending = false;
      restoreControls();
      if (atcText && originalText) atcText.textContent = originalText;
      setStatus(message || 'The item was not confirmed in your cart. Please try again.', false);
    }

    function ambiguousFailure(message) {
      pending = true;
      atc.disabled = true;
      atc.setAttribute('aria-busy', 'false');
      if (atcText) atcText.textContent = 'Review cart before retrying';
      setStatus(message || 'Your cart may have changed, but we could not verify the exact result. Review your cart before trying again.', true);
    }

    function confirmedSuccess() {
      pending = true;
      atc.disabled = true;
      atc.setAttribute('aria-busy', 'true');
      if (atcText) atcText.textContent = 'Added · opening cart';
      setStatus('Added to cart. Opening your cart…', false);
      window.location.assign('/cart');
    }

    form.addEventListener('submit', async function (event) {
      var submitter = event.submitter;
      if (submitter && !submitter.matches('[data-add-to-cart]')) return;

      event.preventDefault();
      if (pending) return;

      var variantId = String(variantInput.value || '').trim();
      var quantity = normalizedQuantity();
      if (!variantId || atc.disabled) {
        setStatus('Choose an available color and size before adding to cart.', false);
        return;
      }

      var originalText = atcText ? atcText.textContent : '';
      pending = true;
      lockControls();
      if (atcText) atcText.textContent = 'Adding…';
      setStatus('Checking your cart…', false);

      var beforeCart = null;
      var beforeQuantity = null;
      var beforeReadSucceeded = false;
      try {
        beforeCart = await readCart();
        beforeQuantity = quantityFor(beforeCart, variantId);
        beforeReadSucceeded = true;
      } catch (error) {
        setStatus('Shopify cart verification is unavailable. Adding once through Shopify…', false);
      }

      var requestCompleted = false;
      var addResponse = null;
      var addData = null;
      var addErrorMessage = '';

      try {
        var payload = new FormData(form);
        payload.set('id', variantId);
        payload.set('quantity', String(quantity));
        addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: payload
        });
        requestCompleted = true;
        addErrorMessage = await responseMessage(addResponse);
        if (addResponse.ok) {
          try { addData = await addResponse.clone().json(); } catch (error) { addData = null; }
        }
      } catch (error) {
        addErrorMessage = 'The network response was interrupted.';
      }

      var returnedVariant = addData && (addData.variant_id || addData.id);
      if (requestCompleted && addResponse && !addResponse.ok) {
        var unavailable = addResponse.status === 422;
        retryableFailure(
          unavailable
            ? (addErrorMessage || 'That selected combination is no longer available. Choose another color or size and try again.')
            : (addErrorMessage || 'Shopify did not confirm the item. Your selections are still here; please try again.'),
          originalText
        );
        return;
      }

      if (requestCompleted && addResponse && addResponse.ok && returnedVariant && String(returnedVariant) !== variantId) {
        ambiguousFailure('Shopify responded, but the returned item did not match the selected variant. Review your cart before retrying.');
        return;
      }

      var afterCart = null;
      var afterReadSucceeded = false;
      try {
        afterCart = await readCart();
        afterReadSucceeded = true;
      } catch (error) {
        afterCart = null;
      }

      if (beforeReadSucceeded && afterReadSucceeded) {
        var afterQuantity = quantityFor(afterCart, variantId);
        var delta = afterQuantity - beforeQuantity;

        if (delta === quantity) {
          confirmedSuccess();
          return;
        }

        if (delta !== 0) {
          ambiguousFailure('Your cart changed by an unexpected quantity. Review your cart before retrying.');
          return;
        }

        if (requestCompleted && addResponse && addResponse.ok) {
          ambiguousFailure('Shopify confirmed the request, but the cart readback did not show the expected item. Review your cart before retrying.');
          return;
        }

        retryableFailure(
          addErrorMessage || 'The item was not confirmed in your cart. Your selections are still here; please try again.',
          originalText
        );
        return;
      }

      if (requestCompleted && addResponse && addResponse.ok && returnedVariant && String(returnedVariant) === variantId) {
        confirmedSuccess();
        return;
      }

      if (afterReadSucceeded && !beforeReadSucceeded && quantityFor(afterCart, variantId) > 0) {
        ambiguousFailure('The selected item is present in your cart, but the exact quantity change could not be verified. Review your cart before retrying.');
        return;
      }

      ambiguousFailure('The add request may have reached Shopify, but the exact cart result could not be verified. Review your cart before retrying.');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
